import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Styles from '../../../common/styles'

class DataGraphPlaceholder extends Component {
  render () {
    return (
      <svg viewBox='0 0 500 100' xmlns='http://www.w3.org/2000/svg' className={this.props.classes.chartSvg}>

        <polyline
          fill='none'
          stroke='#e9e9e9'
          strokeWidth='2'
          points='
       00,120
       40,110
       80,90
       120,85
       160,85
       200,78
       240,70
       280,50
       320,43
       360,41
       400,36
       440,26
       480,20
       500,16
     '
        />

        <g data-setname='Data graph'>
          <circle cx='40' cy='110' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='40' cy='110' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='80' cy='90' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='120' cy='85' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='160' cy='85' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='200' cy='78' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='240' cy='70' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='280' cy='50' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='320' cy='43' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='360' cy='41' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='400' cy='36' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='440' cy='26' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='480' cy='20' data-value='7.2' r='4' fill='#d9d9d9' />
          <circle cx='500' cy='16' data-value='7.2' r='4' fill='#d9d9d9' />
        </g>
      </svg>
    )
  }
}

export default withStyles(Styles)(DataGraphPlaceholder)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/data-graph-placeholder.js